<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#007BFF"
      :is-full-page="true"
    >
    </loading>
    <base-header class="pb-6"> </base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">Productos Plataforma</h3>
            </div>
          </div>
        </div>
        <div class="row starter-page">
          <div class="container-fluid ">
            <vue-content-loading
              v-if="queriedData.length === 0"
              :width="300"
              :height="170"
              primary="#bdc3c7"
              secondary="#95a5a6"
            >
              <svg:rect x="20" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="0" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="15" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="30" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="45" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="60" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="75" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="90" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="105" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="120" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="135" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="150" rx="3" ry="3" width="110" height="8" />
              <circle cx="206" cy="155" r="5" />
              <circle cx="219" cy="155" r="5" />
              <circle cx="232" cy="155" r="5" />
              <circle cx="245" cy="155" r="5" />
            </vue-content-loading>
            <div>
              <base-input
                v-model="searchQuery"
                prepend-icon="fas fa-search"
                placeholder="Buscar..."
              >
              </base-input>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              v-if="queriedData.length !== 0"
              @sort-change="sortChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import BackofficeApi from "../../gateways/backoffice-api";
import { VueContentLoading } from "vue-content-loading";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es";
import Loading from "vue-loading-overlay";
import CustomModal from "../../components/CustomModal";
import "vue-loading-overlay/dist/vue-loading.css";
import Fuse from "fuse.js";

export default {
  name: "ListPlatformList",
  components: {
    // BasePagination,
    VueContentLoading,
    CustomModal,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    flatPicker,
    Loading
  },
  data() {
    return {
      loaded: false,
      searchQuery: "",
      selectedOrder: null,
      searchedData: [],
      isLoading: false,
      tableColumns: [
        {
          prop: "name",
          label: "Producto",
          minWidth: 120,
          sortable: true
        },
        {
          prop: "cost",
          label: "Costo",
          minWidth: 120,
          sortable: true
        },
        {
          prop: "increased_price",
          label: "Precio sugerido plataformas externas",
          minWidth: 120,
          sortable: true
        }
      ],
      orders: []
    };
  },
  async mounted() {
    if (this.darkKitchenId) {
      this.loadOrders();
    }
  },
  computed: {
    darkKitchenId() {
      return this.$store.getters.getKitchenId;
    },
    host() {
      return process.env.VUE_APP_API_BACKOFFICE_URL.replace("/api/v1/", "");
    },
    queriedData() {
      let result = this.orders;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      } else {
        /*  if (this.searchQuery) {
          result = []
        }*/
      }
      return result;
    }
  },
  methods: {
    async changeStatus(row) {
      let response = await BackofficeApi.patch(
        this.host + "/api/v3/restaurants/" + row.id,
        row
      );
    },
    async loadOrders() {
      this.isLoading = true;
      const path = this.host + "/api/v3/kitchens/meals";
      let response = await BackofficeApi.get(path, {
        params: {
          dark_kitchen_id: this.$store.getters.getKitchenId
        }
      });
      this.orders = response.data["detail"]["data"];
      this.fuseSearch = new Fuse(this.orders, {
        keys: ["name"],
        threshold: 0.3
      });
      this.isLoading = false;
      this.loaded = true;
    },
    sortChange({ prop, order }) {
      if (prop) {
        this.orders.sort((a, b) => {
          let aVal = a[prop];
          let bVal = b[prop];
          if (order === "ascending") {
            return aVal > bVal ? 1 : -1;
          }
          return bVal - aVal ? 1 : -1;
        });
      } else {
        this.orders.sort((a, b) => {
          return a.id - b.id;
        });
      }
    }
  },
  watch: {
    searchQuery(value) {
      let result = this.orders;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    darkKitchenId(val) {
      if (!val) return;
      if (!this.loaded && !this.isLoading) {
        this.loadOrders();
      }
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-table .cell {
  word-break: break-word !important;
}
</style>
